import { useSyncExternalStore } from "react";

let enabled = true;
const listeners = new Set<() => void>();
export function setGuideEnabled(value: boolean) {
  enabled = value;
  for (const listener of listeners) listener();
}
export function isGuideEnabled() { return enabled; }
export function useGuideEnabled() {
  return useSyncExternalStore((listener) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  }, isGuideEnabled);
}
